const $ = require('jquery');
const { hasAvailability } = require("./helpers");
const { updateFormSummary } = require("../service-form/service-form");
const { getSelectedSubproduct, showSubproduct} = require('./subproducts-selection');

function getServicePrices(e = null) {
    return new Promise((resolve, reject) => {
        if (currentPriceAjaxRequest !== null) {
            currentPriceAjaxRequest.abort();
        }
        if (e !== null) {
            e.preventDefault();
        }

        var requestData = {
            action: 'get-service-prices',
            service_id: $('#service_id').val(),
            channel: 'KD_WWW',
            people_quantity_adult: $('#people_quantity_adult').val(),
            people_quantity_youth: $('#people_quantity_youth').val(),
            people_quantity_children: $('#people_quantity_children').val(),
            private_or_group: $('#private_or_group').val(),
            request_source: 'KD_WWW',
            company_shortcut: 'KD',
            type_of_transfer: !$('#type_of_transfer').val() ? 3 : $('#type_of_transfer').val(),
            tour_date: $('#tour_date').val(),
            pickup_type: !$('#pickup_type').val() ? 'HOTEL' : $('#pickup_type').val(),
            tour_lang: !$('#tour_lang').val() ? 'ANG' : $('#tour_lang').val()
        };

        currentPriceAjaxRequest = $.ajax({
            url: '/wp-admin/admin-ajax.php', type: 'GET', data: requestData, dataType: 'JSON', beforeSend: function () {
                $('.subproduct-price').html('<i class="fa fa-spinner fa-spin"></i>');
                $('.form-summary #totalPrice').html('<i class="fa fa-spinner fa-spin"></i>');
            }, success: function (response) {
                if (response.success) {
                    var currency = $('#currency').val();
                    resolve(updatePrices(response.data, currency));
                } else {
                    reject(response.message);
                }
            }, error: function (xhr, status, error) {
                console.error("Error:", error);
            }
        });
    });
}

function updatePrices(pricesData, currency) {
    $('.subproduct').removeClass('unavailable');
    $('.subproduct').each(function () {
        $(this).removeClass('d-none');
        var serviceId = $(this).data('service-id');
        var privacyType = $(this).data('privacy-type') === 'Private' ? 'Private' : 'Group';
        var priceContainer = $(this).find('.subproduct-price');
        var priceData = pricesData[serviceId];
        if (!hasAvailability(serviceId, privacyType)) {
            $(this).addClass('unavailable');
            if($(this).data('hide-unavailable') == 1) {
                $(this).addClass('d-none');
            }
            if($(this).hasClass('selected')) {
                showSubproduct()
            }
            priceContainer.html('Sold Out!');
            return;
        }

        if (priceData) {
            var priceType = privacyType === 'Group' ? priceData.group : priceData.private;
            if (priceType && priceType[currency]) {
                priceContainer.html(`${priceType[currency]} ${currency}`);
                if (serviceId == getSelectedSubproduct().service_id && privacyType == $('#private_or_group').val()) {
                    updateFormSummary(`${priceType[currency]} ${currency}`);
                }
            } else {
                priceContainer.html('N/A');
            }
        } else {
            priceContainer.html('N/A');
        }
    });
    $('.subproductsListComponent .form-summary').fadeIn(500);
    $('.subproductsListComponent .preloadMask').fadeOut(300);
}

let currentPriceAjaxRequest = null;

module.exports = { getServicePrices, updatePrices };
